import React, { useEffect } from 'react'
import {
    Grid,
    Typography,
    Button,
    CircularProgress,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormLabel,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@material-ui/core";
import Moment from 'moment'
import { FetchClient, SendUserNewPasswordAction, UpdateUserAction } from '../apis';
import { useHistory } from 'react-router-dom';

export const ClientProfile = ({ user, open, onClose, refresh }) => {
    console.log("client profile")

    const history = useHistory()
    const [userInformation, setUserInformation] = React.useState({
        firstName: user.firstName || "",
        lastName: user.lastName || "",
        email: user.email || "",
        homePhone: user.homePhone || "",
        cellPhone: user.cellPhone || "",
        gender: user.gender || "",
        // linkedin: user.socialMediaHandles.linkedin || "",
        address: user.address || "",
        department: user.department || ""
    });

    const [updateUserLoading, setUpdateUserLoading] = React.useState(false)
    const [sendingPasswordLaoding, setSendingPasswordLaoding] = React.useState(false)


    const handleEditUserInformation = (evt, name) => {
        setUserInformation({ ...userInformation, [name]: evt.target.value })
    }

    const FetchUser = async () => {
        setUpdateUserLoading(true)
        let res = await FetchClient(user.id)
        let newUser = res.data
        setUpdateUserLoading(false)
        setUserInformation({
            ...userInformation,
            firstName: newUser.firstName || "",
            lastName: newUser.lastName || "",
            email: newUser.email || "",
            homePhone: newUser.homePhone || "",
            cellPhone: newUser.cellPhone || "",
            gender: newUser.gender || "",
            // linkedin: newUser.socialMediaHandles.linkedin || "",
            address: newUser.address || "",
            department: newUser.department || ""
        })
    }
    useEffect(() => {
        FetchUser()
    }, [])

    const onUpdateUser = async () => {
        console.log("runnn")
        setUpdateUserLoading(true)
        const update = await UpdateUserAction(user.id, { ...userInformation })
        setUpdateUserLoading(false)
        refresh();
        onClose()
    }


    const sendNewPassord = async () => {
        setSendingPasswordLaoding(true)
        let res = await SendUserNewPasswordAction(user.id)
        setSendingPasswordLaoding(false)
    }

    const seeDashBoard = () => {

        console.log("user:-=-=", user)
        if (user.type === 'COACH' || user.type.toLowerCase() === 'coach' || user.type.toLowerCase() === 'job seeker' || user.type === "JOB_SEEKER") {
            history.push(`client-profile/${user.id}`)
        }
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="form-dialog-title"
            maxWidth="sm"
            fullWidth="100%"
        >
            <DialogTitle id="form-dialog-title">
                <Typography variant="h6">Update User</Typography>
            </DialogTitle>
            <DialogContent>
                <Grid
                    container
                    direction="row"
                    justify="space-between"
                    className="px-5"
                    spacing={2}
                >
                    {/* <Grid item xs={6}>
                <TextField
                    id="date"
                    label="Birthday"
                    type="date"
                    value={Moment(userInformation.dob).format(
                        "YYYY-MM-DD"
                    )}
                    className={classes.textField}
                    InputLabelProps={{
                        shrink: true,
                    }}
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onChange={(evt) => {
                        handleEditUserInformation(evt, "dob");
                    }}
                />
            </Grid> */}
                    <Grid
                        xs={6}
                        item
                        fullWidth
                        container
                        direction="row"
                        justify="start"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item>
                            <FormLabel component="legend">Gender : </FormLabel>
                        </Grid>
                        <Grid item>
                            <RadioGroup
                                aria-label="gender"
                                name="gender1"
                                value={userInformation.gender}
                                onChange={(evt) => {
                                    handleEditUserInformation(evt, "gender");
                                }}
                                row
                            >
                                <FormControlLabel
                                    value="MALE"
                                    control={<Radio />}
                                    label="Male"
                                />
                                <FormControlLabel
                                    value="FEMALE"
                                    control={<Radio />}
                                    label="Female"
                                />
                            </RadioGroup>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Email"
                            value={userInformation.email}
                            variant="outlined"
                            color="secondary"
                            disabled
                            fullWidth
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="First Name"
                            type="text"
                            value={userInformation.firstName}
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "firstName");
                            }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Last Name"
                            type="text"
                            value={userInformation.lastName}
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "lastName");
                            }}
                        />
                    </Grid>

                    <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Home"
                            type="number"
                            value={userInformation.homePhone}
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "homePhone");
                            }}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="Cell"
                            type="number"
                            value={userInformation.cellPhone}
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "cellPhone");
                            }}
                        />
                    </Grid>

                    {/* <Grid item xs={6}>
                        <TextField
                            id="outlined-helperText"
                            label="LinkedIn"
                            value={userInformation.linkedin}
                            variant="outlined"
                            color="secondary"
                            fullWidth
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "linkedin");
                            }}
                        />
                    </Grid> */}
                    <Grid item xs={12}>
                        <TextField
                            id="outlined-helperText"
                            label="Address"
                            fullWidth
                            value={userInformation.address}
                            variant="outlined"
                            color="secondary"
                            onChange={(evt) => {
                                handleEditUserInformation(evt, "address");
                            }}
                        />
                    </Grid>

                    {(user.type === 'Coach' || user.type === 'COACH') && (
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-helperText"
                                label="Department"
                                fullWidth
                                value={userInformation.department}
                                variant="outlined"
                                color="secondary"
                                onChange={(evt) => {
                                    handleEditUserInformation(evt, "department");
                                }}
                            />
                        </Grid>
                    )}

                    <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="end"
                        justifyContent='end'
                    >
                        <Grid item justifyContent='end'>
                            <Button
                                onClick={() => sendNewPassord()}
                                variant={"contained"}
                                className="px-9 py-2"
                            >
                                {sendingPasswordLaoding ? (
                                    <CircularProgress
                                        size={20}
                                    // style={{
                                    //     color: "#ffffff",
                                    //     marginLeft: "5px",
                                    //     marginRight: "5px",
                                    // }}
                                    />
                                ) : (
                                    <Typography
                                    // style={{ width: "30px", height: "20px" }}
                                    >
                                        SEND NEW PASSWORD
                                    </Typography>
                                )}
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        container
                        direction="row"
                        justify="end"
                        justifyContent='end'
                    >
                        <Grid item justifyContent='end'>
                            <Button
                                onClick={() => seeDashBoard()}
                                variant={"contained"}
                                className="px-9 py-2"
                            >
                                {sendingPasswordLaoding ? (
                                    <CircularProgress
                                        size={20}
                                    // style={{
                                    //     color: "#ffffff",
                                    //     marginLeft: "5px",
                                    //     marginRight: "5px",
                                    // }}
                                    />
                                ) : (
                                    <Typography
                                    // style={{ width: "30px", height: "20px" }}
                                    >
                                        See Dashboard
                                    </Typography>
                                )}
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        container
                        direction="row"
                        justify="space-between"
                    >
                        <Grid item>
                            <Button
                                onClick={onClose}
                                variant={"contained"}
                            >
                                Cancel
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                onClick={
                                    updateUserLoading
                                        ? () => { }
                                        : () => onUpdateUser()
                                }
                                color="secondary"
                                variant={"contained"}
                                className="px-9 py-2"
                            >
                                {updateUserLoading ? (
                                    <CircularProgress
                                        size={20}
                                        style={{
                                            color: "#ffffff",
                                            marginLeft: "5px",
                                            marginRight: "5px",
                                        }}
                                    />
                                ) : (
                                    <Typography
                                        style={{ width: "30px", height: "20px" }}
                                    >
                                        SAVE
                                    </Typography>
                                )}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions></DialogActions>
        </Dialog>
    )
} 